import { styled } from '@material-ui/core/styles';
import { Icon } from '@material-ui/core';

const RangeIcon = styled(Icon)({
  width: '100%',
  textAlign: 'center',
  paddingTop: '24px',
  height: '100%',
});

export { RangeIcon };
